import { useState } from 'react';
import { Grid, Button, Typography, TextField, Box, Alert } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import MfproductorderInfo from 'components/mfproductorder/components/MfproductorderInfo';
import { updateproductorderAPI } from 'api/OmsFactoryopsWebServices';
import { updateMfproductorderObj } from 'store/slice/ManufSlice';

export default function UpdateProductOrderActionImpl() {
    const dispatch = useDispatch();
  const [updatedQty, setUpdatedQty] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const {mfproductorderObj} = useSelector((state) => state.manufslice.mfproductorderDashboard);

  // Only allow numbers > 0
  const handleQtyChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setUpdatedQty(value);
  };

  const isSaveEnabled = updatedQty && Number(updatedQty) > 0;

  const handleSave = () => {
    setError('');
    updateproductorderAPI(
      { productOrderId:mfproductorderObj.id,
        qty: updatedQty },
      (response) => {
        dispatch(updateMfproductorderObj(response.mfproductorderInfo));
        setSuccess(true);
        setError('');
      },
      (err) => {
        setSuccess(false);
        setError(err?.message || 'Failed to update Product Order');
      }
    );
  };

  return (
    <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="stretch" sx={{ height: '100%' }}>
      {/* First container: ProductOrderInfo */}
      <Grid item xs={12} md={8}>
        <Box sx={{ p: 2, borderRadius: 2, background: 'white', height: '100%' }}>
          <MfproductorderInfo />
        </Box>
      </Grid>
      {/* Second container: Textarea and Save button */}
      <Grid item xs={12} md={3}>
        <Box sx={{ p: 2, borderRadius: 2, background: 'white', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 200 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Update Quantity</Typography>
          {!success && (
            <>
              <TextField
                label="Enter updated quantity"
                value={updatedQty}
                onChange={handleQtyChange}
                sx={{ mb: 2 }}
                fullWidth
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1 }}
              />
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  disabled={!isSaveEnabled}
                >
                  Save
                </Button>
              </Box>
            </>
          )}
          {success && (
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Alert severity="success" sx={{ width: '100%', textAlign: 'center' }}>
                Product Order is updated successfully
              </Alert>
              <Typography sx={{ mt: 1, fontWeight: 500, textAlign: 'center' }}>
                Please Re-Issue Order Form to reflect updated Product Order Information
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}